import { useState, useEffect } from 'react';

import Icon from '../../../components/AppIcon';
import QuestionCard from './QuestionCard';

const CitySelectionStep = ({ formData, onUpdate, isDirectMode, preselectedPhotographer }) => {
  const [selectedCity, setSelectedCity] = useState(formData?.city || '');

  // In direct mode, only show photographer's city (locked)
  const photographerCity = preselectedPhotographer?.city || preselectedPhotographer?.user?.city;
  
  const cities = [
    { value: 'riyadh', label: 'الرياض', description: 'العاصمة' },
    { value: 'jeddah', label: 'جدة', description: 'عروس البحر الأحمر' },
    { value: 'dammam', label: 'الدمام', description: 'المنطقة الشرقية' },
    { value: 'mecca', label: 'مكة المكرمة', description: 'المدينة المقدسة' },
    { value: 'medina', label: 'المدينة المنورة', description: 'المدينة المنورة' },
    { value: 'khobar', label: 'الخبر', description: 'المنطقة الشرقية' },
    { value: 'taif', label: 'الطائف', description: 'مدينة الورود' },
    { value: 'tabuk', label: 'تبوك', description: 'شمال المملكة' },
    { value: 'abha', label: 'أبها', description: 'عروس الجنوب' },
    { value: 'buraidah', label: 'بريدة', description: 'القصيم' }
  ];

  // Auto-set city in direct mode
  useEffect(() => {
    if (isDirectMode && photographerCity && !selectedCity) {
      // Find matching city value
      const cityMatch = cities.find(c => 
        c.label === photographerCity || 
        c.value === photographerCity?.toLowerCase()
      );
      if (cityMatch) {
        setSelectedCity(cityMatch.value);
        onUpdate({ 
          city: cityMatch.value,
          cityLabel: cityMatch.label
        });
      }
    }
  }, [isDirectMode, photographerCity, selectedCity, onUpdate]);

  const handleCityChange = (value, label) => {
    // In direct mode, prevent changing city
    if (isDirectMode) return;
    
    setSelectedCity(value);
    const selectedCityObj = cities.find(c => c.value === value);
    onUpdate({ 
      city: value,
      cityLabel: label || selectedCityObj?.label || value
    });
  };

  // Filter cities in direct mode
  const availableCities = isDirectMode && photographerCity
    ? cities.filter(c => {
        const cityMatch = c.label === photographerCity || 
                         c.value === photographerCity?.toLowerCase();
        return cityMatch;
      })
    : cities;

  return (
    <QuestionCard
      icon="MapPin"
      title="من أين تود البدء بالبحث؟"
      description={isDirectMode 
        ? `المصور المحدد متاح في ${photographerCity || 'المدينة المحددة'}`
        : "اختر المدينة لتصفية المصورين المتاحين. سيتم التحقق من نطاق الخدمة لاحقاً بناءً على موقعك الدقيق."
      }
    >
      {isDirectMode && photographerCity && (
        <div className="mb-4 p-3 bg-primary/10 border border-primary/20 rounded-lg">
          <p className="text-sm text-primary font-medium">
            المدينة محددة مسبقاً: {photographerCity}
          </p>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {availableCities?.map((city) => (
          <button
            key={city?.value}
            onClick={() => handleCityChange(city?.value, city?.label)}
            className={`p-4 rounded-xl border-2 text-right transition-all hover:border-primary hover:bg-primary/5 ${
              formData?.city === city?.value
                ? 'border-primary bg-primary/10 shadow-sm'
                : 'border-border bg-background'
            }`}
          >
            <div className="flex items-center justify-between">
              <span className="text-base font-medium text-foreground">
                {city?.label}
              </span>
              {formData?.city === city?.value && (
                <Icon name="CheckCircle2" size={20} color="var(--color-primary)" />
              )}
            </div>
          </button>
        ))}
      </div>
    </QuestionCard>
  );
};

export default CitySelectionStep;